/*
 *  @providesModule VirtualCurrencyOffersGridStyle
 *  
 */

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';

import {
  Platform,
  StyleSheet,
} from 'react-native';

const {
  fontPrimary,
  opacityTertiary,
  fontBold,
  fontSizeH3,
  fontSecondary,
  btnTextColorTwo,
  fontRegular,
  textColorPrimary,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },

  footerButtonText: {
    ...textColorPrimary,
    ...fontRegular,
    ...fontBold,
  },

  footerButton: {
    width: 150,
    height: 40,
    marginVertical: 7,
  },

  successModal: {
    width: 250,
    padding: 10,
    alignSelf: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    borderRadius: 5,
  },

  successTitle: {
    marginVertical: 7,
    textAlign: 'center',
    ...fontSizeH3,
    ...fontPrimary,
    ...fontBold,
  },

  successBody: {
    color: 'black',
    marginVertical: 7,
    textAlign: 'center',
  },

  modalOverlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: 'center',

    backgroundColor: SkillzStyle.convertToOpacity(
      '#000000',
      opacityTertiary
    ),
  },
  offersBox: {
    alignSelf: 'stretch',
    alignItems: 'stretch',
    justifyContent: 'center',
    marginHorizontal: Sizes.dynamic({
      phone: 0,
      tablet: 4,
    }),
    flex: 1,
    ...Platform.select({
      web: {
        height: "100%"
      }
    }),
  },
  depositTileBox: {
    height: Sizes.dynamic({
      phone: 80,
      tablet: 105,
    }),
    marginHorizontal: Sizes.select({
      tablet: 8,
      phone: 4,
    }),
    flexGrow: 1,
  },

  rowStyle: {
    alignItems: 'stretch',
    flexDirection: 'row',
    flex: 1,
    height: Sizes.dynamic({
      tablet: 105,
      phone: 85,
    }),
  },
});
